import React from 'react';
import { NextSeo } from 'next-seo';
import Layout from '../components/Layout/Layout';
import { BookmarksPage } from '../components/Views/BookmarksPage';

const Bookmarks = () => (
  <>
    <NextSeo noindex nofollow />
    <BookmarksPage />
  </>
);

Bookmarks.getLayout = function getLayout(page) {
  return <Layout hideMobileHeader>{page}</Layout>;
};

export default Bookmarks;
